import { render, staticRenderFns } from "./StopMarker.vue?vue&type=template&id=144db8da&"
import script from "./StopMarker.vue?vue&type=script&lang=js&"
export * from "./StopMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144db8da')) {
      api.createRecord('144db8da', component.options)
    } else {
      api.reload('144db8da', component.options)
    }
    module.hot.accept("./StopMarker.vue?vue&type=template&id=144db8da&", function () {
      api.rerender('144db8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/mapbox/StopMarker.vue"
export default component.exports